export default __webpack_public_path__ + "static/media/admin-outline-16px.94f62862.svg";